import React, { useState, useEffect } from "react";
import { Box, Grid, Typography, IconButton, Card, CardMedia, CardContent, Rating, Stack, Button } from "@mui/material";

import { CallReceived, CallMade } from "@mui/icons-material";

const NewArrival = () => {
  const products = [
    {
      id: 1,
      title: "Velvet Relaxer Sofa",
      price: "$ 105.00 – $ 130.00",
      rating: 3,
      imageUrl: "https://storage.googleapis.com/a1aa/image/9d09Xo9Moj7XCZJ3kfkeertp0V2GbPgt4TsUw2KeGRG2juaQB.jpg",
      badge: "SALE",
      badgeColor: "black",
    },
    {
      id: 2,
      title: "Table Lamp",
      price: (
        <>
          <span style={{ textDecoration: "line-through" }}>$ 60.00</span>{" "}
          <span style={{ color: "red" }}>$ 55.00</span>
        </>
      ),
      rating: 4,
      imageUrl: "https://storage.googleapis.com/a1aa/image/ODiI2jL9ZvITPpaXmG3lgFF5dBn6Dkl6tfXV6AvsZlrd0VDKA.jpg",
      badge: "8.3% OFF",
      badgeColor: "brown",
    },
    {
      id: 3,
      title: "Round Coffee Table",
      price: "$ 200.00",
      rating: 5,
      imageUrl: "https://storage.googleapis.com/a1aa/image/L1UMDMvofu1UVqdeNf0YJpTH00mf752MQ1VNgVg3ebxxHd1gC.jpg",
      badge: "NEW",
      badgeColor: "blue",
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  const handleNext = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % products.length);
  };

  const handlePrev = () => {
    setActiveIndex((prevIndex) => (prevIndex - 1 + products.length) % products.length);
  };

  const sliderData = [
    {
      image: "/headphone.png",
      subtitle: "COZY CONVERSATION",
      title: "Round Coffee Table",
      bgColor: "#dfe3e2",
    },
    {
      image: "/cable.png",
      subtitle: "RELAX IN STYLE",
      title: "Comfortable Sofa",
      bgColor: "#e3dfdf",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [startX, setStartX] = useState(0);
  const [isDragging, setIsDragging] = useState(false);


  const handleMouseDown = (e) => {
    setStartX(e.clientX);
    setIsDragging(true);
  };

  const handleMouseUp = (e) => {
    if (!isDragging) return;

    const endX = e.clientX;
    const diff = endX - startX;

    if (diff > 50) {
      setCurrentIndex((prevIndex) =>
        prevIndex === 0 ? sliderData.length - 1 : prevIndex - 1
      );
    } else if (diff < -50) {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % sliderData.length);
    }

    setIsDragging(false);
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % sliderData.length);
  };

  // const prevSlide = () => {
  //   setCurrentIndex((prevIndex) =>
  //     prevIndex === 0 ? sliderData.length - 1 : prevIndex - 1
  //   );
  // };

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const currentSlide = sliderData[currentIndex];

  return (
    <Box>
      <Grid container>
        <Grid item xs={12} lg={6}>
          <Box
            sx={{
              width: "100%",
              height: "100%",
              backgroundColor: currentSlide.bgColor,
              position: "relative",
              overflow: "hidden",
              borderRadius: "8px",
              cursor: "grab",
              userSelect: "none",
            }}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            onMouseLeave={() => setIsDragging(false)}
          >
            <Box
              sx={{
                backgroundImage: `url(${currentSlide.image})`,
                backgroundSize: "auto 100%",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                width: "100%",
                height: "400px",
                position: "relative",
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: "25%",
                  left: "10%",
                  transform: "translateY(-50%)",
                  color: "#000",
                }}
              >
                <Typography
                  variant="subtitle2"
                  color="#9E6747"
                  sx={{ letterSpacing: "0.1em" }}
                >
                  {currentSlide.subtitle}
                </Typography>
                <Typography
                  variant="h3"
                  fontWeight="bold"
                  sx={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {currentSlide.title}
                </Typography>
              </Box>
            </Box>

            {/* <Box
              sx={{
                position: "absolute",
                bottom: "10px",
                left: "50%",
                transform: "translateX(-50%)",
                display: "flex",
                gap: "10px",
              }}
            >
              <Button
                variant="contained"
                onClick={prevSlide}
                sx={{ backgroundColor: "#9E6747", color: "#fff" }}
              >
                Previous
              </Button>
              <Button
                variant="contained"
                onClick={nextSlide}
                sx={{ backgroundColor: "#9E6747", color: "#fff" }}
              >
                Next
              </Button>
            </Box> */}
          </Box>
        </Grid>
        <Grid item xs={12} lg={6} sx={{ p: 4 }}>
          <Box mb={6} display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h4" fontSize={"3rem"} fontWeight="bold" sx={{ fontFamily: "'Playfair Display', serif" }}>
              New Arrivals
            </Typography>

            <Box className="hidden md:block lg:block">
              <Box sx={{ display: "flex", gap: 3 }}>
                <IconButton
                  onClick={handlePrev}

                  sx={{
                    border: "1px solid #000",
                    borderRadius: 0,
                    width: "40px",
                    height: "40px",
                    cursor: "pointer",
                    color: "#000",
                    transform: "rotate(45deg)",
                    backgroundColor: "transparent",
                    // boxShadow: 2,
                    "&:hover": { border: "1px solid #9E6747", color: "#9E6747" },
                  }}
                >
                  <CallReceived />
                </IconButton>
                <IconButton
                  onClick={handleNext}
                  sx={{
                    border: "1px solid #000",
                    borderRadius: 0,
                    width: "40px",
                    height: "40px",
                    cursor: "pointer",
                    color: "#000",
                    transform: "rotate(45deg)",
                    backgroundColor: "transparent",
                    // boxShadow: 2,
                    "&:hover": { border: "1px solid #9E6747", color: "#9E6747" },
                  }}
                >
                  <CallMade />
                </IconButton>
              </Box>
            </Box>
          </Box>

          <Box>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={6}> {/* Adjust 'xs' and 'md' based on your layout */}
                <Card
                  elevation={0}
                  sx={{
                    borderRadius: 0,
                    border: 'none',
                    backgroundColor: "#f9f9f9"
                  }}
                >
                  <Box position="relative">
                    <CardMedia
                      component="img"
                      src={products[activeIndex].imageUrl}
                      alt={products[activeIndex].title}
                      sx={{ height: 300, borderRadius: 0 }}
                    />
                    <Box
                      position="absolute"
                      top={8}
                      left={8}
                      bgcolor={products[activeIndex].badgeColor}
                      color="white"
                      px={1}
                      py={0.5}
                      fontSize={12}
                    >
                      {products[activeIndex].badge}
                    </Box>
                  </Box>
                  <CardContent>
                    <Typography variant="h6" fontWeight="bold" sx={{ fontFamily: "'Playfair Display', serif" }}>
                      {products[activeIndex].title}
                    </Typography>
                    <Typography variant="body1" mt={1}>
                      {products[activeIndex].price}
                    </Typography>
                    <Stack direction="row" spacing={0.5} mt={1}>
                      <Rating value={products[activeIndex].rating} readOnly precision={1} size="small" />
                    </Stack>
                  </CardContent>
                </Card>

                <Box
                  className="flex md:hidden lg:hidden justify-center"
                >
                  <Box sx={{ display: "flex", gap: 3 }}>
                    <IconButton
                      onClick={handlePrev}

                      sx={{
                        border: "1px solid #000",
                        borderRadius: 0,
                        width: "40px",
                        height: "40px",
                        cursor: "pointer",
                        color: "#000",
                        transform: "rotate(45deg)",
                        backgroundColor: "transparent",
                        // boxShadow: 2,
                        "&:hover": { border: "1px solid #9E6747", color: "#9E6747" },
                      }}
                    >
                      <CallReceived />
                    </IconButton>
                    <IconButton
                      onClick={handleNext}
                      sx={{
                        border: "1px solid #000",
                        borderRadius: 0,
                        width: "40px",
                        height: "40px",
                        cursor: "pointer",
                        color: "#000",
                        transform: "rotate(45deg)",
                        backgroundColor: "transparent",
                        // boxShadow: 2,
                        "&:hover": { border: "1px solid #9E6747", color: "#9E6747" },
                      }}
                    >
                      <CallMade />
                    </IconButton>
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Card
                  elevation={0}
                  className="hidden md:block"
                  sx={{
                    borderRadius: 0,
                    border: 'none',
                    backgroundColor: "#f9f9f9"
                  }}
                >
                  <Box position="relative">
                    <CardMedia
                      component="img"
                      src={products[(activeIndex + 1)]?.imageUrl || products[activeIndex].imageUrl}
                      alt={products[activeIndex + 1]?.title || products[activeIndex].title}
                      sx={{ height: 300, borderRadius: 0 }}
                    />
                    <Box
                      position="absolute"
                      top={8}
                      left={8}
                      bgcolor={products[activeIndex + 1]?.badgeColor || products[activeIndex].badgeColor}
                      color="white"
                      px={1}
                      py={0.5}
                      fontSize={12}
                    >
                      {products[activeIndex + 1]?.badge || products[activeIndex].badge}
                    </Box>
                  </Box>
                  <CardContent>
                    <Typography variant="h6" fontWeight="bold" sx={{ fontFamily: "'Playfair Display', serif" }}>
                      {products[activeIndex + 1]?.title || products[activeIndex].title}
                    </Typography>
                    <Typography variant="body1" mt={1}>
                      {products[activeIndex + 1]?.price || products[activeIndex].price}
                    </Typography>
                    <Stack direction="row" spacing={0.5} mt={1}>
                      <Rating value={products[activeIndex + 1]?.rating || products[activeIndex].rating} readOnly precision={1} size="small" />
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>



          </Box>
        </Grid>
      </Grid>
    </Box >
  );
};

export default NewArrival;
